// extracted by mini-css-extract-plugin
export var errorIcon = "_ji-1";
export var nameLogo = "_ji-0";